<template>
  <div class="searchbox_outer">
    <v-toolbar flat>
      <div class="nav_wrapper">
        <div class="nav_left">
          <div class="left_sides_analy">
            <v-app-bar-nav-icon class="hidden-sm-and-down" @click="showMenu"
              ><v-icon v-if="!mini">mdi-format-indent-decrease</v-icon
              ><v-icon v-else
                >mdi-format-indent-increase</v-icon
              ></v-app-bar-nav-icon
            >
            <v-app-bar-nav-icon
              class="d-md-none"
              @click="showMenu1"
            ></v-app-bar-nav-icon>
            <div
              :class="{
                nav_input: true,
                'hidden-xs-only': true,
                active: active,
              }"
            >
              <div class="country_icon" @click="openCountry">
                <v-icon>mdi-earth</v-icon>
              </div>
              <div class="combox_style">
                <v-combobox
                  v-model="model"
                  :items="items"
                  label="分析专利..."
                  :multiple="multiple"
                  :search-input.sync="search"
                  @update:search-input="changeName"
                  solo
                  clearable
                  light
                  hide-details
                  hide-selected
                  @keydown.enter="searchPatent"
                  @focus="active = true"
                  @blur="active = false"
                >
                </v-combobox>
              </div>
              <v-btn class="btn_analy" @click="searchPatent">
                <span class="text_btn">分析</span>
              </v-btn>
            </div>
          </div>
          <v-btn
            v-if="isShow"
            class="btn_items hidden-sm-and-down"
            @click="saveAnaly"
          >
            <span class="text_btn">保存分析项目</span>
            <div class="line"></div>
          </v-btn>
          <div class="fix_search_box1" v-if="showTips">
            <div class="desc">
              您可以保存当前检索式分析结果为项目，以便您后续可以进行多次分析。
            </div>
            <div class="tips_wrapper">
              <div class="icon"></div>
              <div class="btn_item" @click="closeTips">我知道了</div>
            </div>
          </div>
          <span
            v-if="isShow"
            class="marleft d-md-none hidden-xs-only"
            @click="saveAnaly"
            ><v-icon>mdi-content-save</v-icon></span
          >
          <!--添加页面跳转到iprbd首页-->
          <div class="alert_iprbd" @click="goback_iprbd">
            <!-- <div class="goback_iprbd" @click="goback_iprbd"></div> -->
             <div class="goback_iprbd" ></div>
            <span class="title">返回旧版</span>
          </div>
          <div class="alert_bell" @click="alertChange">
            <div class="bell_icon"></div>
            <span class="red_point" v-if="redPoint"></span>
          </div>
        </div>
        <div class="nav_right">
          <div class="flex_style right">
            <!-- <div class="user_img  hidden-xs-only">
            <img src="../../assets/images/common/default_user.svg" alt="">
          </div> -->
            <div class="user_name">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <div class="flex_style left" plain v-bind="attrs" v-on="on">
                    <div class="user_img">
                      <!--d-sm-none <v-img src="https://randomuser.me/api/portraits/men/85.jpg"></v-img> -->
                      <img
                        src="../../assets/images/common/default_user.svg"
                        alt=""
                      />
                    </div>
                    <!-- <span class="text tit_overflow  hidden-xs-only">上海美维电子有限公司</span> -->
                    <v-icon class="hidden-xs-only">mdi-chevron-down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item-group v-model="userSel">
                    <v-list-item>
                      <v-list-item-title>{{
                        userInfo.nickName
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-for="(item, index) in userItems"
                      :key="index"
                    >
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>
      </div>
      <div class="nav_wrapper iphone_style d-sm-none">
        <div class="nav_left">
          <div class="nav_input">
            <div class="country_icon" @click="openCountry">
              <v-icon>mdi-earth</v-icon>
            </div>
            <div class="combox_style">
              <v-combobox
                v-model="model"
                :items="items"
                label="分析专利..."
                :multiple="multiple"
                :search-input.sync="search"
                @update:search-input="changeName"
                solo
                clearable
                light
                hide-details
                hide-selected
                @keydown.enter="searchPatent"
              >
              </v-combobox>
            </div>
            <v-btn class="btn_style" @click="searchPatent">
              <span class="text">分析</span>
            </v-btn>
          </div>
          <span class="marleft" @click="saveAnaly"
            ><v-icon>mdi-content-save</v-icon></span
          >
        </div>
      </div>
    </v-toolbar>
    <v-dialog v-model="dialog" width="70%">
      <v-card class="country_dialog">
        <v-card-title class="headline lighten-2"> 搜索范围设定 </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <h4 style="padding: 10px 0" v-if="false">专利类型</h4>
          <v-list class="country_list" v-if="false">
            <v-list-item-group v-model="types" multiple color="primary">
              <v-list-item
                v-for="(b, index) in typeList"
                :key="index"
                :value="b"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="active"
                      color="primary"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content :title="b">
                    <v-list-item-title>
                      {{ b }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
          <!-- <v-divider></v-divider> -->
          <h4 style="padding: 10px 0">全部数据库</h4>
          <v-list class="country_list">
            <v-checkbox
              v-model="isAllCountry"
              :indeterminate="isIndeter1"
              label="全球数据库"
            >
            </v-checkbox>
            <v-list-item-group v-model="country" multiple color="primary">
              <v-list-item
                v-for="(b, index) in cList"
                :key="index"
                :value="b.code"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="active"
                      color="primary"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content :title="b.name">
                    <v-list-item-title>
                      <span :class="['flag', 'flag-' + b.code]"></span>
                      {{ b.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false"> 取消 </v-btn>
          <v-btn color="primary" @click="saveCountry"> 保存 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="saveDialog" width="500">
      <v-card class="country_dialog">
        <v-card-title class="headline lighten-2">保存分析项目</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="padlg">
            <div class="common_input_style">
              <v-text-field
                label="名称"
                v-model="rationName"
                outlined
                placeholder="请输入项目名称，不超过100个字"
                hide-details
              >
              </v-text-field>
            </div>
            <div class="analy_mask_item">
              <span class="label">封面</span>
              <span :class="'img_mask mask' + maskIndex">
                <div class="icon" @click="maskDialog = true">更换</div>
              </span>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleSaveCancel"> 取消 </v-btn>
          <v-btn color="primary" @click="handleSaveOk"> 确定 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="maskDialog" width="500">
      <v-card class="country_dialog">
        <v-card-title class="headline lighten-2">选择封面</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="padlg">
            <div class="mask_img_wrapper">
              <div
                :class="{ img_mask: true, mask0: true, active: maskIndex == 0 }"
                @click="maskIndex = 0"
              ></div>
              <div
                :class="{ img_mask: true, mask1: true, active: maskIndex == 1 }"
                @click="maskIndex = 1"
              ></div>
              <div
                :class="{ img_mask: true, mask2: true, active: maskIndex == 2 }"
                @click="maskIndex = 2"
              ></div>
              <div
                :class="{ img_mask: true, mask3: true, active: maskIndex == 3 }"
                @click="maskIndex = 3"
              ></div>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleMaskCancel"> 取消 </v-btn>
          <v-btn color="primary" @click="handleMaskOk"> 确定 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="alertDialog"
      :fullscreen="true"
      content-class="alert_msg_dialog"
    >
      <div class="alert_msg_wrapper">
        <div class="tit_name">消息通知</div>
        <div class="close_btn" @click="alertDialog = false"></div>
        <div v-if="msgList && msgList.length > 0">
          <div v-show="step == 1">
            <div class="flex_style right marb10">
              <div class="right_btn" @click="readAll">全部标记已读</div>
            </div>
            <div class="table_list_wrapper">
              <v-data-table
                :headers="msgHeader"
                :items="msgList"
                disable-pagination
                hide-default-header
                hide-default-footer
                no-data-text="暂无数据"
                class="common_table"
              >
                <template v-slot:item="{ item }">
                  <div class="line_style hand" @click="goDetail(item)">
                    <div class="td1">
                      <div
                        class="tag"
                        v-if="item.msgType == '专利管家年费监控'"
                      >
                        年费监控
                      </div>
                      <div class="tag" v-else>{{ item.msgType }}</div>
                      <div class="text" v-if="item.hasRead">
                        {{ item.title }}
                      </div>
                      <div class="text_wrapper" v-else>
                        <span class="icon"></span>
                        <span class="text1">{{ item.title }}</span>
                      </div>
                    </div>
                    <!-- <div class="td2">{{item.updatedAt}}</div> -->
                    <div class="td2">{{ item.strDate }}</div>
                  </div>
                </template>
              </v-data-table>
              <div class="common_page">
                <span class="text">共{{ total }}条记录</span>
                <v-pagination
                  v-model="currentPage"
                  :length="length"
                  :total-visible="7"
                >
                </v-pagination>
              </div>
            </div>
          </div>
          <div v-show="step == 2">
            <div class="back_nav_wrapper" @click="goListBack">
              <v-icon>mdi-arrow-left</v-icon>
              <div class="text">返回消息列表</div>
            </div>
            <div class="flex_style left">
              <div class="detail_name1">通知： {{ detailInfo.title }}</div>
              <div class="detail_name2">
                {{ timeFormat(detailInfo.updatedAt) }}
              </div>
            </div>
            <div class="detail_table_wrapper">
              <div>
                <!-- disable-pagination
                        hide-default-footer -->
                <v-data-table
                  :headers="detailHeader"
                  :items="detailList"
                  no-data-text="暂无数据"
                  :items-per-page="10"
                  :footer-props="{
                    itemsPerPageAllText: '全部',
                    itemsPerPageText: '每页',
                    showCurrentPage: true,
                    itemsPerPageOptions: [5, 10, 15, 20, -1],
                  }"
                  class="common_table"
                >
                  <template v-slot:item="{ index, headers, item }">
                    <tr>
                      <td
                        class="text-start"
                        v-for="(item1, index1) in headers"
                        :key="index1"
                      >
                        <div class="tit_overflow" v-if="item1.value == 'index'">
                          {{ index + 1 }}
                        </div>
                        <div
                          class="tit_overflow"
                          v-else-if="item1.value == 'status'"
                        >
                          <div>
                            <span v-if="item.monitorPatent.status == 'NEW'"
                              >最新命中</span
                            >
                            <span
                              v-else-if="
                                item.monitorPatent.status == 'UPDATING'
                              "
                              >最新更新</span
                            >
                            <span
                              v-else-if="item.monitorPatent.status == 'PAYED'"
                              >已缴费</span
                            >
                            <span
                              v-else-if="
                                item.monitorPatent.status == 'WAIT_PAYMENT'
                              "
                              >待缴费</span
                            >
                            <span
                              v-else-if="
                                item.monitorPatent.status == 'EMERGENT'
                              "
                              >紧急</span
                            >
                            <span
                              v-else-if="item.monitorPatent.status == 'LATE'"
                              >滞纳</span
                            >
                            <span
                              v-else-if="item.monitorPatent.status == 'OVER'"
                              >超期</span
                            >
                            <span
                              v-else-if="item.monitorPatent.status == 'UNKNOWN'"
                              >未知</span
                            >
                            <span v-else>--</span>
                          </div>
                        </div>
                        <div
                          class="tit_overflow"
                          v-else-if="item1.value == 'actions'"
                        >
                          <div @click="getFees(item)">
                            <span class="text_blue hand">费用明细</span>
                          </div>
                        </div>
                        <div
                          class="tit_overflow"
                          v-else-if="item.monitorPatent"
                        >
                          {{ item.monitorPatent[item1.value] }}
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="msg_empty_wrapper">
            <div class="img">
              <img src="../../assets/images/icons/nomsg_icon.svg" alt="" />
            </div>
            <div class="text">暂无消息通知</div>
          </div>
        </div>
      </div>
    </v-dialog>
    <v-dialog v-model="feeDialog" width="70%">
      <v-card>
        <v-card-title
          ><span class="fontbold font18">查询费用信息</span>
          <v-icon @click="handleFeeCancel">mdi-close</v-icon></v-card-title
        >
        <v-divider></v-divider>
        <v-card-text>
          <div>
            <v-overlay :absolute="absolute" :value="feeLoading">
              <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
              <div class="white_color">正在获取费用明细，请耐心等待</div>
            </v-overlay>
            <div class="addSpace_wrapper feeInfo_wrapper">
              <div class="fee_top_wrapper marb20">
                <div class="flex_style left marb6">
                  <div class="line_style_item">
                    <div class="label">费用信息查询时间：</div>
                    <div class="value" v-if="feeInfo.monitorDate">
                      {{ timeFormat(feeInfo.monitorDate) }}
                    </div>
                  </div>
                  <div class="line_style_item">
                    <div class="label">专利号：</div>
                    <div class="value">{{ feeInfo.documentNumber }}</div>
                  </div>
                </div>
                <div class="flex_style left">
                  <div class="line_style_item">
                    <div class="label">专利名称：</div>
                    <div class="value">{{ feeInfo.title }}</div>
                  </div>
                  <div class="line_style_item">
                    <div class="label">法律状态：</div>
                    <div class="value">{{ feeInfo.legalStatus }}</div>
                  </div>
                </div>
              </div>
              <div class="fee_center_wrapper">
                <div class="tit_name">未缴费信息</div>
                <div class="table_line_wrapper">
                  <div class="table_box">
                    <div class="tr header">
                      <div class="td">费用种类</div>
                      <div class="td">应缴金额（元）</div>
                      <div class="td">缴费截止日</div>
                      <div class="td">费用状态</div>
                    </div>
                    <div
                      class="tr"
                      v-for="(item, index) in feeData1"
                      :key="index"
                    >
                      <div class="td">{{ item.feeType }}</div>
                      <div class="td">{{ item.amount }}</div>
                      <div class="td">{{ item.date }}</div>
                      <div class="td" v-if="item.state">{{ item.state }}</div>
                      <div class="td" v-else>未知</div>
                    </div>
                  </div>
                </div>
                <div class="tit_name">已缴费信息</div>
                <div class="table_line_wrapper">
                  <div class="table_box">
                    <div class="tr header">
                      <div class="td">费用种类</div>
                      <div class="td">应缴金额（元）</div>
                      <div class="td">缴费截止日</div>
                      <div class="td">费用状态</div>
                    </div>
                    <div
                      class="tr"
                      v-for="(item, index) in feeData2"
                      :key="index"
                    >
                      <div class="td">{{ item.feeType }}</div>
                      <div class="td">{{ item.amount }}</div>
                      <div class="td">{{ item.date }}</div>
                      <div class="td">已缴费</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { count } from "console";
import { mapActions } from "vuex";
import { getPnc } from "../../assets/js/methods.js";
import Qs from "qs";
export default {
  props: ["openSaveDialog", "proInfo","searchKey"],
  data: () => ({
    redPoint: false,
    absolute: true,
    feeLoading: false,
    isLoading: false,
    items: [],
    searchKey:"",
    userItems: [
      {
        title: "个人信息",
      },
      {
        title: "历史语句",
      },
      {
        title: "退出登录",
      },
    ],
    msgHeader: [], //添加的字段
    model: null,
    search: null,
    tab: null,
    key: "",
    multiple: false,
    dialog: false,
    country: [],
    cList: [],
    rspnation:
      "cn;;;jp;;;us;;;kr;;;wo;;;de;;;gb;;;fr;;;ca;;;tw;;;au;;;es;;;ru;;;zn;;;at;;;it;;;in;;;br;;;eu;;;se;;;no;;;ch;;;fi;;;dk;;;pl;;;mx;;;nl;;;be;;;il;;;hk;;;za;;;my;;;hu;;;pt;;;ar;;;ua;;;cz;;;id;;;nz;;;sg;;;gr;;;ro;;;ea;;;ie;;;tr;;;cl;;;yu;;;vn;;;ph;;;si;;;pe;;;bg;;;hr;;;sk;;;co;;;lu;;;ap;;;uy;;;cy;;;rs;;;md;;;th;;;tn;;;ec;;;lt;;;eg;;;oa;;;ma;;;mn;;;mo;;;cr;;;lv;;;ee;;;gt;;;is;;;cu;;;mc;;;ge;;;do;;;jo;;;pa;;;sa;;;gc;;;sm;;;me;;;sv;;;ni;;;zw;;;hn;;;bn;;;zm;;;dz;;;mt;;;bh;;;py;;;ke;;;mw;;;ve;;;tj;;;ae;;;bo;;;ba;;;kz;;;bd;;;iq;;;by;;;la;;;kh;;;sy;;;uz;;;az;;;mk;;;tm;;;am;;;kg;;;tt",
    types: [],
    typeList: ["发明公开", "实用新型", "外观设计", "发明授权"],
    saveDialog: false,
    rationName: "",
    isAllCountry: false,
    isIndeter1: false,
    list: [],
    userSel: "",
    userInfo: "",
    isShow: false,
    maskIndex: 0,
    maskDialog: false,
    active: false,
    showTips: false,
    saveInfo: {},
    alertDialog: false,
    step: 1,
    currentPage: 1,
    pageSize: 16,
    msgList: [],
    total: 0,
    length: 0,
    detailHeader: [],
    detailHeader4: [
      {
        text: "序号",
        align: "start",
        sortable: false,
        value: "index",
      },
      {
        text: "申请号",
        align: "start",
        sortable: false,
        value: "applicationNumber",
      },
      {
        text: "专利名称",
        align: "start",
        sortable: false,
        value: "title",
      },
      {
        text: "专利类型",
        align: "start",
        sortable: false,
        value: "patentType",
      },
      {
        text: "专利状态",
        align: "start",
        sortable: false,
        value: "currentStatus",
      },
      {
        text: "申请日",
        align: "start",
        sortable: false,
        value: "applicationDateString",
      },
      {
        text: "原专利权人",
        align: "start",
        sortable: false,
        value: "inventor",
      },
      {
        text: "专利权人",
        align: "start",
        sortable: false,
        value: "inventor",
      },
    ],
    detailHeader3: [
      {
        text: "序号",
        align: "start",
        sortable: false,
        value: "index",
      },
      {
        text: "申请号",
        align: "start",
        sortable: false,
        value: "applicationNumber",
      },
      {
        text: "专利名称",
        align: "start",
        sortable: false,
        value: "title",
      },
      {
        text: "当前状态",
        align: "start",
        sortable: false,
        value: "status",
      },
      // {
      //     text: '之前状态',
      //     align: 'start',
      //     sortable: false,
      //     value: ''
      // },
      // {
      //     text: '之后状态',
      //     align: 'start',
      //     sortable: false,
      //     value: ''
      // },
      {
        text: "申请人",
        align: "start",
        sortable: false,
        value: "applicant",
      },
      {
        text: "申请日",
        align: "start",
        sortable: false,
        value: "applicationDateString",
      },
      {
        text: "发明人",
        align: "start",
        sortable: false,
        value: "inventor",
      },
    ],
    detailHeader2: [
      {
        text: "序号",
        align: "start",
        sortable: false,
        value: "index",
      },
      {
        text: "申请号",
        align: "start",
        sortable: false,
        value: "applicationNumber",
      },
      {
        text: "专利名称",
        align: "start",
        sortable: false,
        value: "title",
      },
      {
        text: "专利类型",
        align: "start",
        sortable: false,
        value: "patentType",
      },
      {
        text: "专利状态",
        align: "start",
        sortable: false,
        value: "currentStatus",
      },
      {
        text: "申请人",
        align: "start",
        sortable: false,
        value: "applicant",
      },
      {
        text: "申请日",
        align: "start",
        sortable: false,
        value: "applicationDateString",
      },
      {
        text: "缴费截止日",
        align: "start",
        sortable: false,
        value: "deadlineString",
      },
      {
        text: "应缴费",
        align: "start",
        sortable: false,
        value: "fee",
      },
      {
        text: "监控操作",
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    detailHeader1: [
      {
        text: "序号",
        align: "start",
        sortable: false,
        value: "index",
      },
      {
        text: "申请号",
        align: "start",
        sortable: false,
        value: "applicationNumber",
      },
      {
        text: "专利名称",
        align: "start",
        sortable: false,
        value: "title",
      },
      {
        text: "专利类型",
        align: "start",
        sortable: false,
        value: "patentType",
      },
      {
        text: "专利状态",
        align: "start",
        sortable: false,
        value: "currentStatus",
      },
      {
        text: "申请人",
        align: "start",
        sortable: false,
        value: "applicant",
      },
      {
        text: "申请日",
        align: "start",
        sortable: false,
        value: "applicationDateString",
      },
      {
        text: "发明人",
        align: "start",
        sortable: false,
        value: "inventor",
      },
    ],
    detailInfo: {},
    detailList: [],
    feeData1: [],
    feeData2: [],
    feeInfo: {},
    feeDialog: false,
    timer: "",
  }),
  computed: {
    mini() {
      return this.$store.state.mini;
    },
    analyStr() {
      return this.$store.state.analyStr;
    },
    analyFilterData() {
      return JSON.stringify(this.$store.state.analyFilterData);
    },
  },
  created() {
  },
  mounted() {
    if (!this.model) {
      this.model = this.$route.query.str || this.$store.state.searchKey;
      if (this.model && this.$route.path == "/search/result") {
        this.searchPatent();
      }
    }
    if (this.$route.path.indexOf("/analyse/classify") > -1) {
      if (this.$route.query.currentName) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    } else {
      this.isShow = false;
    }
    this.getUserInfo();
    this.getMessageList();
    this.currentPage = 1;
    this.timer = setInterval(() => {
      this.getMessageList();
    }, 60000);
    if (this.$route.path.indexOf("/analyse/classify") > -1) {
      if (!localStorage.getItem("fixed-search1") && this.isShow) {
        this.showTips = true;
      }
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  watch: {
    openSaveDialog(val) {
      this.saveDialog = val;
    },
    proInfo(val) {
      this.saveInfo = val;
      this.maskIndex = val.cover;
      this.rationName = val.name;
    },
    userSel(val) {
      if (val == "3") {
        this.goOut();
      }
      if (val == "2") {
        this.$router.push({
          path: "/user/history",
        });
      }
      if (val == "1") {
        this.$router.push({
          path: "/user/baseData",
        });
      }
    },
    model(val) {
      // if (val != null) this.tab = 0
      // else this.tab = null
      // if (val.length > this.items.length) {
      //   this.$nextTick(() => this.model.pop())
      // }
    },
    analyStr(val) {
      this.model = val;
    },
    search(val) {
      this.key = val;
      this.isLoading = true;
      this.getSuggest(val);
    },
    country(val) {
      if (val.length >= this.list.length) {
        this.isAllCountry = true;
        this.isIndeter1 = false;
      } else if (val.length > 0) {
        this.isIndeter1 = true;
      } else {
        this.isIndeter1 = false;
        this.isAllCountry = false;
      }
    },
    isAllCountry(val) {
      if (val) {
        this.country = this.list;
      } else {
        this.country = [];
      }
    },
  },
  methods: {
    ...mapActions("search", ["querySug"]),
    ...mapActions("analy", ["analySave", "updateSavePro"]),
    ...mapActions("common", ["logOut"]),
    ...mapActions("user", ["personalInfo"]),
    ...mapActions("manager", [
      "getNotiMsgList",
      "getNotiMsgDetail",
      "readNotiMsg",
      "annualFeeInfo",
    ]),
    //页面跳转到iprbd的首页
    goback_iprbd() {
      window.location.href = "https://www.iprdb.com";
    },
    getUserInfo() {
      let _this = this;
      let data = {
        params: {
          tag: "user_info",
        },
      };
      this.personalInfo({
        data: data,
        handle(res) {
          let info = res.user;
          _this.userInfo = info;
        },
      });
    },
    showMenu() {
      this.$store.commit("setMenuMini", !this.mini);
    },
    showMenu1() {
      // this.$store.commit('setMenuDraw', true)
      this.$store.commit("setMenuMini", true);
    },
    searchPatent() {
      if (this.key && this.key != this.model) {
        this.model = this.key;
      }
      if (this.model && this.model.text) {
        this.model = this.model.text;
      }
      if (this.model) {
        this.$store.commit("setCountryChange", true);
        this.$store.commit("setAnalyStr", this.model);
        this.$emit("getKey", this.model);
      } else {
        // alert('请输入搜索关键字')
        this.$message({
          type: "info",
          message: "请输入搜索关键字",
        });
        return false;
      }
      if (this.$route.path != "/analyse/classify/all") {
        this.$router.push({
          path: "/analyse/classify/all",
          query: {
            str: this.model,
          },
        });
      } else {
        let name = "";
        if (this.$route.query.currentName) {
          name = "&currentName" + this.$route.query.currentName;
        }
        this.$router.replace("?str=" + this.model + name);
      }
    },
    changeName(val) {
      this.key = val;
    },
    getSuggest(val) {
      this.items = [];
      let _this = this;
      let data = {
        params: {
          q: val,
        },
      };
      this.querySug({
        data: data,
        handle(res) {
          _this.isLoading = false;
          let data = res.data;
          let newData = [];
          if (data && data.length > 0) {
            data.forEach((item) => {
              newData.push(item.text);
            });
          }
          _this.items = newData;
        },
      });
    },
    openCountry() {
      this.dialog = true;
      this.getCountrys();
      let country = localStorage.getItem("countries1");
      if (country) {
        this.country = JSON.parse(country);
      } else {
        this.country = ["cn"];
      }
    },
    getCountrys() {
      let list = this.rspnation.split(";;;");
      this.list = list;
      list.forEach((item) => {
        let c = {
          name: getPnc(item),
          code: item,
        };
        this.cList.push(c);
      });
    },
    saveCountry() {
      let country = JSON.stringify(this.country);
      localStorage.setItem("countries1", country);
      this.dialog = false;
    },
    goLogin() {
      this.$router.push({
        path: "/login",
      });
    },
    saveAnaly() {
      this.saveDialog = true;
    },
    handleSaveOk() {
      if (this.saveInfo.id) {
        this.saveInfo.cover = this.maskIndex;
        this.saveInfo.name = this.rationName;
        let _this = this;
        let data = Qs.stringify(this.saveInfo);
        this.updateSavePro({
          data: data,
          handle(res) {
            _this.$message({
              type: "success",
              message: res.message,
            });
            _this.saveDialog = false;
            _this.$emit("watchSaDialog", false);
          },
        });
      } else {
        let data = {
          params: {
            q: this.model,
            rationName: this.rationName,
            fc: this.analyFilterData,
            q2: "",
            wfId: "",
            cover: this.maskIndex,
          },
        };
        let _this = this;
        this.analySave({
          data: data,
          handle(res) {
            if (res.success) {
              _this.$message({
                type: "success",
                message: res.message,
              });
              _this.saveDialog = false;
              _this.$emit("watchSaDialog", false);
            }
          },
        });
      }
    },
    handleSaveCancel() {
      this.saveDialog = false;
      this.$emit("watchSaDialog", false);
    },
    goOut() {
      let _this = this;
      this.logOut({
        handle(res) {
          _this.$router.push({
            path: "/",
          });
        },
      });
    },
    handleMaskCancel() {
      this.maskIndex = 0;
      this.maskDialog = false;
    },
    handleMaskOk() {
      this.maskDialog = false;
    },
    closeTips() {
      this.showTips = false;
      localStorage.setItem("fixed-search1", "show");
    },
    alertChange() {
      this.alertDialog = true;
      this.getMessageList();
      this.step = 1;
    },
    getMessageList() {
      this.redPoint = false;
      let data = {
        params: {
          p: this.currentPage,
          pageSize: this.pageSize,
        },
      };
      let _this = this;
      this.getNotiMsgList({
        data: data,
        handle(res) {
          let list = res.pagination.data;
          if (list && list.length > 0) {
            list.forEach((item) => {
              if (!item.hasRead) {
                _this.redPoint = true;
              }
            });
          }
          _this.msgList = res.pagination.data;
          _this.total = res.pagination.total;
          _this.length = res.pagination.totalPages;
        },
      });
    },
    goListBack() {
      this.step = 1;
      this.getMessageList();
    },
    readAll() {
      let data = {};
      let _this = this;
      this.readNotiMsg({
        data: data,
        handle(res) {
          if (res.success) {
            _this.$message({
              type: "success",
              message: res.message,
            });
            _this.getMessageList();
          } else {
            _this.$message({
              type: "info",
              message: res.message,
            });
          }
        },
      });
    },
    goDetail(val) {
      if (val.type == "ASSISTANT_NEW") {
        this.detailHeader = this.detailHeader1;
      } else if (val.type == "ASSISTANT_FEE") {
        this.detailHeader = this.detailHeader2;
      } else if (val.type == "ASSISTANT_STATUS") {
        this.detailHeader = this.detailHeader3;
      } else {
        this.detailHeader = this.detailHeader4;
      }
      this.detailInfo = val;
      this.step = 2;
      let data = {
        params: {
          id: val.id,
          t: val.type,
        },
      };
      let _this = this;
      this.getNotiMsgDetail({
        data: data,
        handle(res) {
          if (res.contentList) {
            _this.detailList = res.contentList;
          } else {
            _this.detailList =
              res.contentMap.NEW ||
              res.contentMap.UPDATING ||
              res.contentMap.PAYED ||
              res.contentMap.WAIT_PAYMENT ||
              res.contentMap.EMERGENT ||
              res.contentMap.LATE ||
              res.contentMap.OVER ||
              res.contentMap.UNKNOWN;
          }

          _this.detailInfo = res.bean;
        },
      });
    },
    getFees(val) {
      this.feeData1 = [];
      this.feeData2 = [];
      this.feeInfo = val.monitorPatent;
      this.feeDialog = true;
      console.log("val", val);
      let data = {
        params: {
          applicationNumber: val.monitorPatent.applicationNumber,
        },
      };
      this.feeLoading = true;
      let _this = this;
      this.annualFeeInfo({
        data: data,
        handle(res) {
          _this.feeLoading = false;
          if (res.code == "0") {
            let list = JSON.parse(res.FeeInfo);
            let data1 = [];
            list.forEach((item) => {
              if (item.type == "应缴费信息") {
                data1.push(item);
              }
            });
            data1.sort((a, b) => {
              return new Date(a.date).getTime() - new Date(b.date).getTime();
            });
            let data2 = [];
            list.forEach((item) => {
              if (item.type == "已缴费信息") {
                data2.push(item);
              }
            });
            data2.sort((a, b) => {
              return new Date(a.date).getTime() - new Date(b.date).getTime();
            });
            _this.feeData1 = data1;
            _this.feeData2 = data2;
          } else {
            _this.$message({
              type: "info",
              message: res.message,
            });
          }
        },
      });
    },
    handleFeeCancel() {
      this.feeDialog = false;
    },
    timeFormat(unixTime) {
      let date = new Date(unixTime);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      return Y + M + D;
    },
  },
};
</script>
<style scoped>
.searchbar {
  width: 100%;
  text-align: center;
}
.searchbar span {
  font-style: italic;
  color: blanchedalmond;
}
</style>